import { css } from '@emotion/react'
import { Heading, HFlow, Tag, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { Telefone } from 'components/label'
import { isUndefinedOrNull } from 'util/checks'
import { tipoEnderecoIndigena } from 'view/cadastro-imovel/model-cadastroImovel'
import {
  getBairroFormatado,
  getImovelCepFormatado,
  getImovelEnderecoFormatado,
  getTipoImovelIcon,
} from 'view/visualizacaoTerritorial/utils/visualizacaoTerritorialUtils'

import { ImovelHeaderDto } from '../model-visualizacao-imovel'
import { MapLink } from './MapLink'

interface VisualizarImovelHeaderContentProps {
  imovel: ImovelHeaderDto
  isProntuarioFamiliar?: boolean
}

export const VisualizarImovelHeaderContent = ({ imovel, isProntuarioFamiliar }: VisualizarImovelHeaderContentProps) => {
  const {
    tipoImovel,
    bairro,
    cep,
    logradouro,
    nomeTipoLogradouro,
    nomeMunicipio,
    siglaUfMunicipio,
    complemento,
    numero,
    telefoneContato,
    telefoneResidencial,
    condicoesMoradia,
    microarea,
    latitude,
    longitude,
    tipoEndereco,
    numeroResidenciaIndigena,
    aldeia,
    poloBase,
    dsei,
  } = imovel

  const theme = useTheme()
  const { divider } = createStyles(theme)

  const isTipoEnderecoIndigena = tipoEndereco && tipoEnderecoIndigena.includes(tipoEndereco)
  const hasGeolocalizacao = !isUndefinedOrNull(latitude) && !isUndefinedOrNull(longitude)

  const { HeaderIcon, tooltip } = getTipoImovelIcon(tipoImovel, condicoesMoradia?.tipoDomicilio)

  return (
    <HFlow style={isProntuarioFamiliar && divider}>
      <HeaderIcon
        style={{
          width: '100%',
          height: '100%',
        }}
      />
      <VFlow vSpacing={0.4}>
        <HFlow>
          {isTipoEnderecoIndigena && aldeia ? (
            <Heading level={1}>
              {aldeia.nome.titleCase()}, {numeroResidenciaIndigena}
            </Heading>
          ) : (
            <Heading level={1}>
              {getImovelEnderecoFormatado({ logradouro, nomeTipoLogradouro, numero, complemento })}
            </Heading>
          )}
          <Tag
            type='normal'
            style={css`
              margin-top: 0.4rem;
            `}
          >
            {tooltip}
          </Tag>
        </HFlow>
        {isTipoEnderecoIndigena && aldeia ? (
          <Text>{`DSEI: ${dsei?.nome?.titleCase()} | Polo base: ${poloBase?.nome?.titleCase()}`}</Text>
        ) : (
          <Text>
            {complemento ? `${complemento?.titleCase()} - ` : ''}
            {getBairroFormatado(bairro)}
            {` - ${nomeMunicipio?.titleCase()}/${siglaUfMunicipio?.toUpperCase()}`}
            {getImovelCepFormatado(cep, true)}
          </Text>
        )}

        <HFlow>
          <HLabel title='Microárea'>{microarea === 'S/N' ? 'Fora de área' : microarea}</HLabel>
          <HLabel title='Telefone de contato'>{telefoneContato && <Telefone value={telefoneContato} />}</HLabel>
          <HLabel title='Telefone residencial'>
            {telefoneResidencial && <Telefone value={telefoneResidencial} />}
          </HLabel>
          <HLabel title='Geolocalização'>
            {hasGeolocalizacao ? <MapLink latitude={latitude} longitude={longitude} /> : undefined}
          </HLabel>
        </HFlow>
      </VFlow>
    </HFlow>
  )
}

const createStyles = (theme: Theme) => ({
  divider: css`
    border: 1px solid ${theme.pallete.divider};
    padding: 1rem;
    margin-bottom: 1rem;
  `,
})
